import * as Sentry from '@sentry/nextjs';
import BlogPosts from 'components/blog/BlogPosts';
import Button from 'components/buttons/button';
import Divider from 'components/divider';
import Layout from 'components/layout';
import Anchor from 'components/typography/anchor';
import { getAllPostsforTileByCategory } from 'lib/api/posts';
import PropTypes from 'prop-types';
import config from 'siteconfig';
import { BLOG_CATEGORIES } from 'utilities/blog';
import { BlogPostTileType } from 'utilities/propTypes';

const REVALIDATE_TIME_MINUTES = 5;
const REVALIDATE_TIME_SECONDS = REVALIDATE_TIME_MINUTES * 60;

export const getStaticProps = Sentry.wrapGetStaticPropsWithSentry(async () => {
  return {
    props: {
      posts: await getAllPostsforTileByCategory({ limit: 6 }),
    },
    revalidate: REVALIDATE_TIME_SECONDS,
  };
});

const NewsSection = ({ category, postsForCategory, isLast }) => {
  const strings = BLOG_CATEGORIES[category];
  const [heading, body] = strings;

  return postsForCategory.length ? (
    <>
      <div className={'mb-1'}>
        <h2>{heading}</h2>
        <div>{body}</div>
      </div>
      <BlogPosts posts={postsForCategory}></BlogPosts>

      <Button
        theme="outline"
        href={`/${config.blog.baseURL}/category/${category}`}
      >
        More
      </Button>

      {!isLast && <Divider />}
    </>
  ) : null;
};

const NewsLander = ({ posts }) => {
  const nationalPosts = posts.national || [];
  const statePosts = posts.state || [];
  const resistbotPosts = posts.resistbot || [];

  const sections = [
    { name: 'national', posts: nationalPosts },
    { name: 'state', posts: statePosts },
    { name: 'resistbot', posts: resistbotPosts },
  ];

  const postSections = sections.map((categoryDefinition, index) => {
    const isLast = index === sections.length - 1;

    return (
      <NewsSection
        key={categoryDefinition.name}
        category={categoryDefinition.name}
        postsForCategory={categoryDefinition.posts}
        isLast={isLast}
      />
    );
  });

  return (
    <Layout
      title="Resistbot News"
      description="Opinion articles from our volunteers and news about Resistbot features."
    >
      <h1>News & Opinion</h1>
      <p className="mb-4">
        Issue articles are written by volunteers and reflect their own opinions.
        You don’t have to take these positions when contacting your officials.
        If you’d like to write for us,{' '}
        <Anchor className="anchor-text" href="/about#contact-support">
          get in&nbsp;touch!
        </Anchor>
      </p>

      {postSections}
    </Layout>
  );
};

NewsSection.propTypes = {
  category: PropTypes.string.isRequired,
  postsForCategory: PropTypes.arrayOf(BlogPostTileType).isRequired,
  isLast: PropTypes.bool,
};

NewsLander.propTypes = {
  posts: PropTypes.exact({
    national: PropTypes.PropTypes.arrayOf(BlogPostTileType).isRequired,
    state: PropTypes.PropTypes.arrayOf(BlogPostTileType).isRequired,
    resistbot: PropTypes.PropTypes.arrayOf(BlogPostTileType).isRequired,
    podcast: PropTypes.PropTypes.arrayOf(BlogPostTileType).isRequired,
  }),
};

export default NewsLander;
